import React, { useEffect, useState } from "react";
// import { Table } from "react-bootstrap";
import { Button, Form } from "react-bootstrap";
import * as Icons from "heroicons-react";
import { useNavigate, useParams } from "react-router-dom";
import CategorySelectByMC from "../Common/CustomSelect/categorySelectByMC";
import SelectBrand from "../Common/CustomSelect/selectBrand";
import SelectMC from "../Common/CustomSelect/selectMC";
import SelectUnit from "../Common/CustomSelect/selectUnit";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import productImage from "../../product.jpg";
import { notify } from "../Utility/Notify";
import {
  useUpdateProductMutation,
  useProductPromoQuery,
} from "../../services/productApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import ProductPriceModal from "../Common/Modal/ProductPriceModal";
import { useDispatch } from "react-redux";
import { Toaster } from "react-hot-toast";
import { useForm } from "react-hook-form";
import { signInUser } from "../Utility/Auth";
import PhotoUploader from "../Common/photoUpload/photoUpload";

const UpdateProducts = () => {
  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
    // console.log('BASE_URL', BASE_URL)

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const auth = signInUser();
  const { aamarId } = auth;
  const [mc, setMc] = useState("");
  const [sc, setSc] = useState("");
  const [scValue, setScValue] = useState("");
  const [brand, setBrand] = useState([]);
  const [unit, setUnit] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [promoType, setPromoType] = useState(false);

  const [spp, setSpp] = useState({});
  const [hover, setHover] = useState(false);
  // const [promoPriceID, setPromoPriceID] = useState("")
  const [slug, setSlug] = useState("");
  const [isEANUnique, setIsEANUnique] = useState(true);
  const [isArticleCodeUnique, setIsArticleCodeUnique] = useState(true);
  // const [preLoadValue, setPreLoadValue] = useState({});
  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useProductPromoQuery(`${id}`);

  // console.log("update product list", data);

  const {
    register,
    handleSubmit,
    control,
    setError,
    clearErrors,
    watch,
    setValue,
    reset,

    formState: { errors },
  } = useForm({});
  const [priceModal, setPriceModal] = useState(false);

  //  slug create in Product name

  // handle change in slug field
  const handleNameChange = (e) => {
    const name = e.target.value;
    // Generate slug in real-time
    const generatedSlug = name.trim().toLowerCase().replace(/\s+/g, "_");
    setSlug(generatedSlug);
    setValue("slug", generatedSlug); // Update slug in react-hook-form
  };

  // eanValue & articleCode value should  auto generate a unique value
  const eanValue = watch("ean");
  const articleCodeValue = watch("article_code");
  useEffect(() => {
    const isEANValid = eanValue && /^[0-9]+$/.test(eanValue); // Check if eanValue is a number
    if (isEANValid) {
      checkEan(eanValue);
    }

    const isAcValid = articleCodeValue && /^[0-9]+$/.test(articleCodeValue); // Check if articleCodeValue is a number
    if (isAcValid) {
      checkAC(articleCodeValue);
    }
  }, [eanValue, articleCodeValue]);

  const checkEan = async (ean) => {
    // console.log(ean);
    try {
      const eanData = await axios.get(
        `${BASE_URL}product/update/uniqueEan/${ean}/${id}`
      );
      const { eanExists } = eanData.data; // Correct property name
      if (eanExists) {
        setIsEANUnique(false);
        setError("ean", { message: "EAN code already exists!" });
      } else {
        setIsEANUnique(true);
        clearErrors("ean");
      }
    } catch (error) {
      console.error("Error checking EAN code:", error);
    }
  };

  const checkAC = async (ac) => {
    try {
      // console.log(ac);
      const acData = await axios.get(
        `${BASE_URL}product/update/uniqueAc/${ac}/${id}`
      );
      const { acExists } = acData.data; // Ensure this matches the backend response

      if (acExists) {
        setIsArticleCodeUnique(false);
        setError("article_code", { message: "Article code already exists!" });
      } else {
        setIsArticleCodeUnique(true);
        clearErrors("article_code");
      }
    } catch (error) {
      console.error("Error checking Article Code:", error);
    }
  };

  const handlePriceModalClose = () => {
    setPriceModal(false);
    refetch();
  };

  useEffect(() => {
    if (data) {
      reset({
        _id: data._id,
        name: data.name,
        ean: data.ean,
        article_code: data.article_code,
        master_category: data.master_category,
        category: data.category,
        product_type: data.product_type,
        priceList: data.priceList,
        brand: data.brand,
        slug: data.slug,
        details: data.details,
        unit: data.unit,
        alert_quantity: data.alert_quantity,
        vat: data.vat,
        vat_method: data.vat_method,
        featured: data.featured,
        shipping_method: data.shipping_method,
        hide_website: data.hide_website,
        // promo_price: data?.promo_price?._id,
        // checked: data?.isPercentage,
        promo_price: data?.promo_price,
        promo_type: promoType,
        promo_start: data?.promo_start
          ? new Date(data?.promo_start)
          : new Date(),
        promo_end: data?.promo_end ? new Date(data?.promo_end) : new Date(),
        specification: data?.specification,
        // photo: data?.photo ? data?.photo : "",
        status: data?.status,
      });
      setMc(data?.master_category);
      setBrand(data?.brand);
      setScValue(data?.category);
      setUnit(data?.unit);
      setPromoType(data?.promo_type === undefined ? false : data?.promo_type);
      // setChecked(data?.promo_type === undefined ? false : data?.promo_type)
      setEndDate(data?.promo_end ? new Date(data?.promo_end) : new Date());
      setStartDate(
        data?.promo_start ? new Date(data?.promo_start) : new Date()
      );
      // setSpp({
      //   label: `${
      //     data?.promo_price?.mrp === undefined
      //       ? "No Price"
      //       : data?.promo_price?.mrp
      //   } BDT`,
      //   option: data?.promo_price?._id,
      // });
    }
    // setUploadedFile({
    //   fileName: data?.name,
    //   filePath: data?.photo && data?.photo,
    // });
  }, [data, dispatch]);
  // console.log(uploadFile);

  // const [updateProduct] = useUpdateProductMutation();
  const [updateProduct] = useUpdateProductMutation();

  const onSubmit = async (fromData) => {
    console.log("data form", fromData);
    // console.log("Brand:", fromData.brand);


    const response = await updateProduct(fromData);
    // const formData = new FormData();
    // formData.append("file", data.file[0]);
    // console.log(response);
    if (response) {
      // console.log("Update Product SuccessFull");

      // console.log(response);
      notify("Product Update Successful!", "success");
      navigate("/product");
    } else {
      notify("Product Update Filed!", "error");
    }
  };

  // SUPPLIER SELECT HANDLE
  const handleOnchangeMasterCategory = (e) => {
    // console.log(e)
    if (e.label) {
      let mId = e.label.split(" - ");
      // console.log("object", mId[1]);

      setSc(mId[1]);
    }
    setMc(e.option);
    setValue("master_category", e.option, {
      shouldValidate: true,
      shouldDirty: true,
    });
    // reset({
    //   master_category: e.option,
    // });
  };

  //category
  const handleOnchangeCategory = (e) => {
    console.log("handle category", e);
    setScValue(e.option);
    setValue("category", e, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  // console.log('brand Set', brand)
  //Brand
  const handleOnChangeBand = (e) => {
    // console.log("Brand e",e.option)
    setBrand(e.option);
    setValue("brand", e.option, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleOnchangeUnit = (e) => {
    // console.log("Unit e",e)
    setUnit(e.option);
    setValue("unit", e.option, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  const handlePromoStart = (date) => {
    setStartDate(date);
    setValue("promo_start", date, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handlePromoEnd = (date) => {
    setEndDate(date);
    setValue("promo_end", date, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handlePriceModalShow = () => {
    setPriceModal(true);
  };

  const handlePromoType = (e) => {
    setPromoType(!promoType);
    setValue("promo_type", !promoType, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const updatePhotUrl = async (url) => {
    // console.log('URL::>>', url);
    const pData = {
      _id: data?._id,
      photo: url,
    };
    // console.log("pData", pData);

    const response = await updateProduct(pData);
    if (response) {
      console.log("Update Product SuccessFull", response);
      // refetch();

      // console.log(response);
      notify("Product photo Upload Successful!", "success");
      // navigate("/product");
    } else {
      notify("Product Update Filed!", "error");
    }
  };

  // console.log("data", data);
  return (
    <div>
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Update Product"></Header>
            <div className="row  mt-3">
              <div className="col-md-8">
                <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
                  {/* 1st row */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="masterCategory" className="form-label">
                          Master Category
                        </label>
                        <input
                          type="hidden"
                          placeholder="Master Category"
                          id="masterCategory"
                          aria-describedby="masterHelp"
                          className="form-control"
                          {...register("master_category", { required: true })}
                        />
                        <SelectMC
                          mc={mc}
                          handleOnchange={(e) => {
                            handleOnchangeMasterCategory(e);
                          }}
                        ></SelectMC>
                        <div id="masterHelp" className="form-text">
                          Product Master Category
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="ean" className="form-label">
                          EAN Code{" "}
                        </label>
                        <input
                          placeholder="EAN CODE"
                          className="form-control"
                          id="ean"
                          aria-describedby="eanHelp"
                          {...register("ean", {
                            required: true,
                            maxLength: 13,
                          })}
                        />
                        {!isEANUnique && (
                          <span className="text-danger">
                            EAN code already exists!
                          </span>
                        )}
                        <div id="eanHelp" className="form-text">
                          International EAN CODE
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="p_type">
                          Product Type
                        </label>
                        <select
                          className="form-select"
                          {...register("product_type")}
                        >
                          <option value="standard">Standard</option>
                          <option value="combo">combo</option>
                          <option value="offer">Offer</option>
                        </select>
                        {/* <input placeholder='Product Type' className="form-control" id="p_type" aria-describedby="typeHelp" {...register("type", { required: true, maxLength: 20 })} /> */}
                        <div id="typeHelp" className="form-text">
                          Single or Combo Product
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 2nd row */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_name">
                          Product Name
                        </label>
                        <input
                          placeholder="Product name"
                          className="form-control"
                          id="p_name"
                          aria-describedby="nameHelp"
                          {...register("name", {
                            required: "* This Field is Required",
                            onChange: handleNameChange, // Real-time slug generation
                          })}
                        />
                        <div id="nameHelp" className="form-text">
                          Product Name with pack size
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_article_code">
                          Article Code
                        </label>
                        <input
                          placeholder="Article Code"
                          className="form-control"
                          id="p_article_code"
                          aria-describedby="article_codeHelp"
                          {...register("article_code", {
                            required: true,
                            maxLength: 13,
                          })}
                        />
                        {!isArticleCodeUnique && (
                          <span className="text-danger">
                            Article code already exists!
                          </span>
                        )}
                        <div id="article_codeHelp" className="form-text">
                          Article code start with Master Category id
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 3rd row  */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_brand">
                          Brand
                        </label>
                        <input
                          placeholder="Brand"
                          type="hidden"
                          className="form-control"
                          id="p_brand"
                          aria-describedby="brandHelp"
                          {...register("brand")}
                        />

                        <SelectBrand
                          brand={brand}
                          handleOnchange={(e) => handleOnChangeBand(e)}
                        />

                        {/* <div id="brandHelp" className="form-text">
                          Article code start with Master Category id
                        </div> */}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_category">
                          Category
                        </label>
                        <input
                          placeholder="Category"
                          type="hidden"
                          className="form-control"
                          id="p_category"
                          aria-describedby="categoryHelp"
                          {...register("category", {
                            required: true,
                          })}
                        />
                        <CategorySelectByMC
                          scValue={scValue}
                          sc={sc}
                          handleOnChangeCategory={handleOnchangeCategory}
                        />
                        <div id="categoryHelp" className="form-text">
                          Article code start with Master Category id
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_slug">
                          Slug
                        </label>
                        <input
                          type="text"
                          placeholder="Slug"
                          className="form-control"
                          id="p_slug"
                          aria-describedby="slugHelp"
                          {...register("slug")}
                          value={data?.slug || slug}
                        />
                        <div id="slugHelp" className="form-text">
                          Article code start with Master Category id
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 4th row  */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_unit_code">
                          Product Unit
                        </label>
                        {/* <input placeholder='Product Unit' className="form-control" id="p_unit_code" aria-describedby="unit_codeHelp" {...register("unit_code", { maxLength: 20 })} /> */}
                        <SelectUnit
                          unit={unit}
                          handleOnchange={(e) => handleOnchangeUnit(e)}
                        ></SelectUnit>
                        <div id="unit_codeHelp" className="form-text">
                          Article code start with Master Category id
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_slug">
                          Alert Quantity
                        </label>
                        <input
                          type="number"
                          placeholder="Alert Quantity"
                          className="form-control"
                          id="p_alert_quantity"
                          aria-describedby="alert_quantityHelp"
                          {...register("alert_quantity", {
                            required: true,
                            maxLength: 20,
                          })}
                        />
                        <div id="alert_quantityHelp" className="form-text">
                          Alert Quantity must 
                        </div>
                      </div>
                    </div>
                    {/* weightScale field */}
                    <div className="col-md-5">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="p_weightScale_code"
                        >
                          Weight Scale
                        </label>

                        {/* Product Type select with react-hook-form validation */}
                        <select
                          className="form-select"
                          {...register("weightScale", {
                            required: "* This Field is Required",
                          })}
                        >
                          <option value="false">Inactive</option>
                          <option value="true">active</option>
                        </select>

                        {/* Error message for Product weightScale */}
                        {errors.weightScale && (
                          <span className="text-danger mt-2">
                            {errors.weightScale.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* 5th row  */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_vat">
                          VAT
                        </label>
                        <input
                          type="text"
                          placeholder="VAT"
                          className="form-control"
                          id="p_vat"
                          aria-describedby="vatHelp"
                          {...register("vat", {
                            required: true,
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_vat_method">
                          Vat Method
                        </label>
                        {/* <input placeholder='Vat Method' className="form-control" id="p_vat_method" aria-describedby="vat_methodHelp" {...register("vat_method", { required: true, maxLength: 20 })} /> */}
                        <select
                          className="form-select"
                          {...register("vat_method")}
                        >
                          <option value="true">Include</option>
                          <option value="false">Exclude</option>
                        </select>
                        <div id="vat_methodHelp" className="form-text">
                          Vat Include or Not
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label" htmlFor="p_shipping">
                          Status
                        </label>
                        <select className="form-select" {...register("status")}>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                        {/* <input type="checkbox" className="form-check-input me-2" {...register("hide_website")} id="hide_on_website" /> */}

                        <div id="hide_on_websiteHelp" className="form-text">
                          Is this product hide on E-commerce?
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 6th row  */}
                  {auth?.storeSettings?.isEnableApi ? (
                    <>
                      {/* 7th row */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="mb-3 ">
                            <label className="form-label" htmlFor="p_shipping">
                              Featured
                            </label>
                            <select
                              className="form-select"
                              {...register("featured")}
                            >
                              <option value="true">Featured</option>
                              <option value="false">Non-Featured</option>
                            </select>
                            {/* <input type="checkbox" className="form-check-input me-2" {...register("featured")} id="featured" /> */}
                            <div id="featuredHelp" className="form-text">
                              Is this product featured on E-commerce?
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3 ">
                            <label className="form-label" htmlFor="p_shipping">
                              Web Site
                            </label>
                            <select
                              className="form-select"
                              {...register("hide_website")}
                            >
                              <option value="true">Show Web Site</option>
                              <option value="false">Hide Web Site</option>
                            </select>
                            {/* <input type="checkbox" className="form-check-input me-2" {...register("hide_website")} id="hide_on_website" /> */}

                            <div id="hide_on_websiteHelp" className="form-text">
                              Is this product hide on E-commerce?
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3 ">
                            <label className="form-label" htmlFor="p_shipping">
                              Shipping Method
                            </label>
                            {/* <input placeholder='shipping' className="form-control" id="p_shipping" aria-describedby="shippingHelp" {...register("shipping", { required: true, maxLength: 20 })} /> */}
                            <select
                              className="form-select"
                              {...register("shipping")}
                            >
                              <option value="cod">COD</option>
                              <option value="free">Free Shipping</option>
                              <option value="uttara">Inside Uttara</option>
                            </select>
                            <div id="shippingHelp" className="form-text">
                              What is the delivery method?
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 8th row */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3 ">
                            <label
                              className="form-label"
                              htmlFor="p_product_details"
                            >
                              Product Description
                            </label>
                            <textarea
                              placeholder="Product Description"
                              className="form-control"
                              id="p_product_details"
                              aria-describedby="product_detailsHelp"
                              {...register("details", { required: false })}
                            />
                            <div id="product_detailsHelp" className="form-text">
                              Product Details for E-commerce
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3 ">
                            <label
                              className="form-label"
                              htmlFor="p_product_specification"
                            >
                              Product Specification
                            </label>
                            <textarea
                              placeholder="Product Specification"
                              className="form-control"
                              id="p_product_specification"
                              aria-describedby="product_specificationHelp"
                              {...register("specification", {
                                required: false,
                              })}
                            />
                            <div
                              id="product_specificationHelp"
                              className="form-text"
                            >
                              Product Details for E-commerce
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {/* 9th row */}
                  <div className="row g-3 align-items-end mb-4">
                    {/* Promotional Price */}
                    <div className="col-md-6 align-content-end">
                      <div className=" ">
                        <div className="d-flex justify-content-between ">
                          <div className="col-md-8">
                            <label
                              className="form-label"
                              htmlFor="p_promotional_price"
                            >
                              Promo Price{" "}
                            </label>
                            <input
                              type="number"
                              placeholder="Promotional Price"
                              className="form-control"
                              id="p_promotional_price"
                              aria-describedby="promotional_priceHelp"
                              {...register("promo_price", { required: false })}
                            />
                          </div>
                          <div className="d-flex justify-content-around align-items-end p-1">
                            <Form.Check
                              type="checkbox"
                              checked={promoType ? "checked" : ""}
                              // checked={data?.promo_type === undefined ? false : data?.promo_type}
                              id="custom-switch"
                              onChange={() => handlePromoType()}
                              label=""
                            />
                            <label
                              className="form-check-label text-sm"
                              for="flexCheckDefault"
                            >
                              Percentage
                            </label>
                          </div>
                        </div>
                        {/* <PriceSelectByProductPromoPrice
                          data={data}
                          handleOnChangePP={handleOnChangePP}
                          spp={spp}
                        /> */}

                        {/* <div id="promotional_priceHelp" className="form-text">
                          Product Cost{" "}
                        </div> */}
                      </div>
                    </div>

                    {/* Promo Starts */}
                    <div className="col-md-2">
                      <label htmlFor="p_promotion_start" className="form-label">
                        Promo Starts
                      </label>
                      <DatePicker
                        className="form-control"
                        selected={new Date(startDate)}
                        {...register("promo_start", { required: false })}
                        onChange={handlePromoStart}
                      />
                      <div className="form-text">Start date for promotion</div>
                    </div>

                    {/* Promo Ends */}
                    <div className="col-md-2">
                      <label htmlFor="p_promotion_ends" className="form-label">
                        Promo Ends
                      </label>
                      <DatePicker
                        className="form-control"
                        selected={endDate}
                        {...register("promo_end", { required: false })}
                        onChange={handlePromoEnd}
                      />
                      <div className="form-text">End date for promotion</div>
                    </div>

                    {/* Add Price */}
                    <div className="col-md-2 text-end">
                      <label
                        htmlFor="p_add_price"
                        className="form-control d-flex align-items-center justify-content-center cursor-pointer"
                        onClick={handlePriceModalShow}
                        style={{
                          // You can adjust padding as needed
                          cursor: "pointer",
                          backgroundColor: hover ? "#f2f2f3" : "#f8f9fa",
                          color: hover ? "#000" : "#000",
                        }}
                        onMouseEnter={() => setHover(true)} // Handle mouse hover
                        onMouseLeave={() => setHover(false)} // Handle mouse leave
                      >
                        <Icons.CurrencyBangladeshiOutline className="me-2" />
                        Add Price
                      </label>
                    </div>
                  </div>

                 

                  <button
                    type="submit"
                    className="btn btn-dark"
                    // onClick={console.log("Click")}

                    disabled={!isEANUnique || !isArticleCodeUnique}
                  >
                    Update
                  </button>
                </form>
              </div>
              <div className="col-md-4">
                <PhotoUploader
                  uploadSuccess={updatePhotUrl}
                  aspectRatio={1 / 1}
                  folderName={aamarId}
                  maxFileSize={1 * 1024 * 1024} // 1MB
                  acceptedFileTypes={[
                    "image/jpg",
                    "image/jpeg",
                    "image/svg",
                    "image/png",
                    "image/webp",
                  ]}
                  image={data?.photo || null}
                  placeholder={productImage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
      <ProductPriceModal
        show={priceModal}
        handleClose={handlePriceModalClose}
        productId={data?._id}
      ></ProductPriceModal>
      {/* <DevTool control={control} placement="top-left" /> */}
    </div>
  );
};

export default UpdateProducts;
